class SizeGuideModal extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ['close']
  }

  constructor() {
    super()
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  connectedCallback() {
    this.triggers = document.querySelectorAll('.size-guide-trigger')
    super.connectedCallback()
  }

  setupListeners() {
    super.setupListeners()

    // Open
    this.triggers.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.open.bind(this))
    })

    // Close
    this.els.close?.elements?.forEach(el => {
      this.listeners.add(el, 'click', this.close.bind(this))
    })

    // Keyboard (ESC + TAB trap)
    this.listeners.add(document, 'keydown', this.handleKeydown)

    if (window.location.hash === '#size-guide') {
      this.open()
    }
  }

  open() {
    this.lastFocusedElement = document.activeElement
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')

    // Single rAF — DOM + CSS have now both updated
    requestAnimationFrame(() => {
      this.focusableElements[0]?.focus()

      this.querySelectorAll('size-guide-slider').forEach(slider => {
        slider.carousel?.update()
      })
    })
  }

  close() {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('util-SiteOverflowed')

    requestAnimationFrame(() => {
      this.lastFocusedElement?.focus()
    })
  }

  handleKeydown(e) {
    const isOpen = this.getAttribute('aria-hidden') === 'false'
    if (!isOpen) return

    if (e.key === 'Escape') {
      this.close()
      return
    }

    if (!this.contains(document.activeElement)) return

    if (e.key !== 'Tab') return

    const focusable = this.focusableElements
    if (!focusable.length) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault()
      last.focus()
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault()
      first.focus()
    }
  }

  get focusableElements() {
    return Array.from(this.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    ))
  }
}

customElements.define('size-guide-modal', SizeGuideModal)
